"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entitlementSlugsForAccount = entitlementSlugsForAccount;
exports.resolveUserEntitlementsForAccount = resolveUserEntitlementsForAccount;
exports.accountHasPackageSlug = accountHasPackageSlug;
const package_catalog_1 = require("./package-catalog");
const package_billing_1 = require("./package-billing");
const package_entitlements_1 = require("./package-entitlements");
const pro_trial_1 = require("./pro-trial");
/** Slugs για entitlements: FREE → basic· FREE+δοκιμή → basic+pro· PRO → ενεργές συνδρομές. */
function entitlementSlugsForAccount(input) {
    if (input.plan === 'FREE') {
        if ((0, pro_trial_1.isProTrialActive)(input)) {
            return [package_catalog_1.PRO_PACKAGE_SLUG, 'pro'];
        }
        return [package_catalog_1.PRO_PACKAGE_SLUG];
    }
    return [...new Set(input.activePackageSlugs)];
}
function resolveUserEntitlementsForAccount(catalog, input) {
    const slugs = entitlementSlugsForAccount(input);
    const expanded = (0, package_billing_1.expandPackageIncludes)(catalog, slugs);
    return Array.from((0, package_entitlements_1.resolveFeatureKeysForSlugs)(catalog, expanded));
}
/** Έλεγχος πρόσβασης σε slug (μετά expansion includes). */
function accountHasPackageSlug(catalog, input, requiredSlug) {
    const slugs = entitlementSlugsForAccount(input);
    const expanded = (0, package_billing_1.expandPackageIncludes)(catalog, slugs);
    return expanded.has(requiredSlug);
}
